import { useEffect, useMemo, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Card,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  InputAdornment,
} from '@mui/material';
import {
  getPermissionRole,
  setPermissionRole,
} from '../../store/nerisSettingsAuthoritiesReducer';
import TableRowItem from './TableRowItem';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';

const NerisAuthorities = () => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState('');
  const { employeesList, rolesList, loadingEmployeesList } = useSelector(
    (state) => state.nerisSettingsAuthoritiesReducer
  );

  useEffect(() => {
    dispatch(getPermissionRole());
  }, [dispatch]);

  const employeesListSearched = useMemo(
    () =>
      employeesList.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      ),
    [employeesList, searchQuery]
  );

  const setRoleHandler = (employeeId, superAdminValue) => {
    const payloadData = {
      employee: employeeId,
      role: superAdminValue,
    };

    dispatch(setPermissionRole(payloadData));
  };

  const clearSearch = () => {
    setSearchQuery('');
  };

  return (
    <Card
      className="p-3 mt-4"
      sx={{
        boxShadow: '0px 4px 4px 0px #0000000F',
      }}
    >
      <Typography variant="h5" component="h1" sx={{ mb: 3, fontWeight: 600 }}>
        Neris Authorities
      </Typography>

      <Box sx={{ maxWidth: '500px', mb: 3 }}>
        <TextField
          color="secondary"
          label="Search members"
          placeholder="Search by members name..."
          size="small"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchQuery.length > 0 ? (
                  <ClearIcon onClick={clearSearch} sx={{ cursor: 'pointer' }} />
                ) : (
                  <SearchIcon />
                )}
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {loadingEmployeesList || rolesList.length === 0 ? (
        <Box
          sx={{ minHeight: '100px' }}
          className="w-100 h-100 d-flex justify-content-center align-items-center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Table size="small" sx={{ maxWidth: 900 }}>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: '#f5f5f5 !important',
              }}
            >
              <TableCell>Members</TableCell>
              <TableCell>Rank</TableCell>
              <TableCell>Role</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employeesListSearched?.map((item) => (
              <TableRowItem
                key={employeesListSearched.id}
                item={item}
                setRoleHandler={setRoleHandler}
                rolesList={rolesList}
              />
            ))}
          </TableBody>
        </Table>
      )}
    </Card>
  );
};

export default NerisAuthorities;
